import { CANCELLATION_OPTIONS } from 'modules/arena/onboarding/content';
import { Card } from 'shared/components/ui/Card';
import { Button } from 'shared/components/ui/Button';
import { useToast } from 'shared/components/ui/Toast';
import { useArenaProfile } from 'shared/contexts/ArenaProfileContext';

export function CancellationPolicyCard() {
  const toast = useToast();
  const { profile } = useArenaProfile();
  const policy = CANCELLATION_OPTIONS.find((option) => option.value === profile.cancellationWindow) ?? CANCELLATION_OPTIONS[0];
  const refund = profile.cancellationWindow === 'sem-reembolso' ? 0 : profile.refundPercentage;

  return (
    <Card>
      <div className="flex items-center justify-between">
        <h3 className="font-heading font-semibold text-ink">Política de cancelamento</h3>
        <Button
          variant="ghost"
          className="px-3 py-1 text-xs"
          onClick={() =>
            toast({
              tone: 'info',
              title: 'Editar política de cancelamento',
              description: 'Em breve: prazos e percentuais de reembolso. Pedidos já feitos mantêm a política da época.',
            })
          }
        >
          Editar
        </Button>
      </div>
      <p className="mt-2 text-sm font-medium text-ink">{policy.label}</p>
      <p className="text-sm text-ink-secondary">{policy.description}</p>
      <p className="mt-2 text-xs text-ink-secondary">Reembolso de {refund}% do valor pago</p>
    </Card>
  );
}
